<div *ngIf="show" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[60]" (click)="close()">
  <div class="relative top-20 mx-auto p-5 border w-11/12 max-w-4xl shadow-lg rounded-md bg-gray-800" (click)="$event.stopPropagation()">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg leading-6 font-medium text-gray-200">Selecteer Afbeelding</h3>
      <button
        (click)="close()"
        class="text-gray-400 hover:text-white transition-colors">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Upload Section -->
    <div class="mb-4 flex items-center gap-3">
      <label
        class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 cursor-pointer transition-colors"
        [class.opacity-50]="uploading"
        [class.pointer-events-none]="uploading">
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
        </svg>
        Uploaden
        <input
          type="file"
          accept="image/*"
          class="hidden"
          (change)="onFileSelected($event)"
          [disabled]="uploading">
      </label>
      <div *ngIf="uploading" class="flex-1 flex items-center gap-3">
        <div class="flex-1 bg-gray-700 rounded-full h-2 overflow-hidden">
          <div class="bg-indigo-500 h-2 rounded-full transition-all duration-300" [style.width.%]="uploadProgress"></div>
        </div>
        <span class="text-xs text-gray-400 whitespace-nowrap">{{ uploadStatus }}</span>
      </div>
    </div>

    <div class="mt-4">
      <!-- Loading State -->
      <div *ngIf="loading" class="flex justify-center items-center py-12">
        <div class="text-gray-400">Afbeeldingen laden...</div>
      </div>

      <!-- Media Grid -->
      <div *ngIf="!loading && filteredFiles.length > 0" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-h-96 overflow-y-auto">
        <div
          *ngFor="let file of filteredFiles"
          (click)="selectImage(file)"
          class="relative aspect-square bg-gray-700 rounded-lg overflow-hidden cursor-pointer hover:ring-2 hover:ring-indigo-500 transition-all group">
          <img
            [src]="file.url"
            [alt]="file.name"
            class="w-full h-full object-cover"
            loading="lazy">
          <div class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity"></div>
          <div class="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
            <p class="text-xs text-white truncate">{{ file.name }}</p>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!loading && filteredFiles.length === 0" class="text-center py-12">
        <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <p class="mt-2 text-sm text-gray-400">Geen afbeeldingen gevonden</p>
        <p class="mt-1 text-xs text-gray-500">Upload eerst afbeeldingen in de media bibliotheek</p>
      </div>

      <!-- Pagination -->
      <div *ngIf="!loading && (hasPrevPage || hasNextPage)" class="mt-4 flex items-center justify-between border-t border-gray-700 pt-4">
        <button
          type="button"
          (click)="prevPage()"
          [disabled]="!hasPrevPage"
          class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-300 bg-gray-700 rounded-lg hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed">
          <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
          Vorige
        </button>
        <span class="text-sm text-gray-400">Pagina {{ currentPageIndex + 1 }}</span>
        <button
          type="button"
          (click)="nextPage()"
          [disabled]="!hasNextPage"
          class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-300 bg-gray-700 rounded-lg hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed">
          Volgende
          <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>


